import { useEffect } from 'react';
import store from "../../../../store";
import {setSelectedFilters} from "../../../../actions/actionFunctions";
import {setGroheFiltersSearchText} from "../../../../actions/groheFunctions";

const useResetState = () => {

  useEffect (() => {
    store.dispatch(setSelectedFilters([]));
    store.dispatch(setGroheFiltersSearchText(""));
  }, []);
};

export default useResetState;
